import { render, staticRenderFns } from "./vue-field.vue?vue&type=template&id=b4c58c84"
import script from "./vue-field.vue?vue&type=script&lang=js"
export * from "./vue-field.vue?vue&type=script&lang=js"
import style0 from "./vue-field.vue?vue&type=style&index=0&id=b4c58c84&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports